const $video = document.querySelector('.video') ?? false;

const init = () => {
	if (!$video) {
		return;
	}

	const $videoPlay = document.querySelectorAll('.video__play');

	$videoPlay.forEach((play) => {
		play.addEventListener('click', (e) => {
			const card = e.target.closest('.video__card');
			const poster = card.querySelector('.video__poster');
			const iframe = card.querySelector('.video__iframe');

			poster.classList.add('is-hidden');
			iframe.setAttribute('src', iframe.dataset.src);
		});
	});
};

export default {
	init,
};
